import React from 'react';
import Main from './Components/Main'

function App() {
  return (
    <div className="container">
      <Main />
    </div>
  )
}

export default App